import { falAngleRight } from 'shared/@generated/icons/falAngleRight';
import { Props } from 'shared/@types';
import { Post } from 'shared/@generated/models';
import { TouchableOpacity, View } from 'react-native';
import { Text } from 'shared/components/text';
import { Icon } from 'shared/components/icon';
import { MarkdownView } from 'shared/components/markdown-view';
import useApi from 'shared/library/use-api';
import { useEffect, useRef, useState } from 'react';
import { apiRoute } from 'shared/library/api-route';
import { Loader } from 'shared/components/loader';
import { clsx } from 'clsx';
import { useRouter } from 'shared/library/use-router';

export function FaqCard({ post }: Props<{ post: Post }>) {
  const [expanded, setExpanded] = useState(false);
  const [fullPost, setFullPost] = useState<Post | null>(null);
  const { request, loading } = useApi();
  const { asPath } = useRouter();
  const containerRef = useRef<View>(null);
  const anchor = post.slug['en'];

  function loadPost() {
    request<{ post: Post }>(apiRoute('posts.show', { post: post.slug['en'] })).then((data) =>
      setFullPost(data.post),
    );
  }

  function toggleExpanded() {
    setExpanded(!expanded);

    if (!fullPost && !loading) {
      loadPost();
    }
  }

  // Global search links to a question with its slug as the URL hash.
  useEffect(() => {
    if (decodeURIComponent(asPath.split('#')[1] ?? '') !== anchor) {
      return;
    }

    setExpanded(true);
    if (!fullPost) loadPost();
    (containerRef.current as unknown as HTMLElement | null)?.scrollIntoView?.({ block: 'center' });
  }, [asPath, anchor]);

  return (
    <View
      ref={containerRef}
      nativeID={anchor}
      className={'border-brand-brown-dark/10 border-b py-3'}
    >
      <TouchableOpacity
        className={'group flex-row items-center gap-1.5 hover:opacity-75'}
        onPress={toggleExpanded}
      >
        <Text
          className={clsx('text-brand-brown-dark flex-1 group-hover:underline', {
            'font-bold': expanded,
          })}
        >
          {post.title}
        </Text>

        <Icon icon={falAngleRight} className={'text-brand-brown-dark/50'} />
      </TouchableOpacity>

      {expanded && <View>{fullPost ? <MarkdownView markdown={fullPost.body} /> : <Loader />}</View>}
    </View>
  );
}
